/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2021-12-21 10:21:40
 *
 *******************************************************/
//@flow

import React, { Component } from 'react';
import { TextContainer, Link, RadioButton, Icon } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { URL } from 'src/constants/links';
import { ExternalMinor } from '@shopify/polaris-icons';

type Props = {};

type ComposedProps = Props & WithI18nProps;

class AfterSubmit extends Component<ComposedProps> {
  render() {
    const { i18n, option, removeAll } = this.props;
    const suffixType = removeAll === true ? 'All' : 'Search';
    return (
      <TextContainer>
        {(
          (option === 2 && !removeAll) ||
          (option === 4 && removeAll)
        ) ? (
          <React.Fragment>
            <RadioButton
              label={i18n.translate(
                `AdminHTML.ThemeSetup.FeedbackModal.option${option}_${suffixType}_RadioButton_Label`
              )}
              checked={true}
              id={option}
              name="options"
            />
            <p style={{ marginLeft: '1.75rem' }}>
              {i18n.translate(
                `AdminHTML.ThemeSetup.FeedbackModal.option${option}_${suffixType}_Paragraph_Gratitude`,
                (option === 2 && !removeAll) ? {
                  nt_break: <br />,
                  t1: (
                    <span className='img-new-tab'>
                      <Link external url={`${URL['ThemeSetupDoc_SuccessLink']}`}>
                        {i18n.translate(
                          `AdminHTML.ThemeSetup.FeedbackModal.option${option}_${suffixType}_Paragraph_Gratitude_t1`
                        )}
                        <Icon source={ExternalMinor} color="interactive" />
                      </Link>
                    </span>
                  )
                } : {}
              )}
            </p>
          </React.Fragment>
        ) : (
          <p>
            {i18n.translate(
              `AdminHTML.ThemeSetup.FeedbackModal.option${option}_${suffixType}_Paragraph_Gratitude`
            )}
          </p>
        )}
      </TextContainer>
    );
  }
}
export default withI18n()(AfterSubmit);
